import React, {useEffect, useMemo, useState} from 'react'
import {Button, Card, CardBody, CardHeader, Col, Input, Modal, Row} from "reactstrap";
import IcoMoon from "react-icomoon";
import {useDropzone} from "react-dropzone";
import axios from "axios";
import {ButtonContainer} from "@pages/reusable-components/styled-components";

import { API_URL, formatDate } from '@constants/index';
import IconSet from "@assets/selection.json";
import TableCustom from 'views/pages/components/TableCustom'
import notify from "@utils/notify";
const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out"
}

const activeStyle = {
    borderColor: "#2196f3"
}

const acceptStyle = {
    borderColor: "#00e676"
}

const rejectStyle = {
    borderColor: "#ff1744"
}
interface VehicleDocuments {
    vehicleInitial: any,
    id: number | string,

}

const VehicleDocuments: React.FC<VehicleDocuments> = ({id,vehicleInitial}) => {

    const [imageType, setImageType] = useState('vehicle_document')
    const [fileLists, setFileLists] = useState([])
    const [inspectionDocuments, setInspectionDocuments] = useState([])
    const [vehicle, setVehicle] = useState({})
    const [documents, setDocuments] = useState([])
    const [deliveryReportDocuments, setDeliveryReportDocuments] = useState([])
    const [imageTypes] = useState([
        {
            value: 'vehicle_document',
            text: 'Vehicle Documents'
        },
        {
            value: 'inspection_documents',
            text: 'Vehicle Inspection'
        },
        {
            value: 'delivery_documents',
            text: 'Delivery Reports'
        },
    ])
    const [deleteModal, setDeleteModal] = useState({
        show: false,
        header: '',
        body: '',
        onClick: null,
    })
    useEffect(() => {
        getData('documents').then(res => {
            const filteredDocuments = res.documents.filter(doc => {
                return !res.inspectionDocuments
                    .filter(inspecDoc => inspecDoc.document)
                    .some(inspecDoc => inspecDoc.document.id === doc.id);
            });
            setDocuments(filteredDocuments)
            setInspectionDocuments(res.inspectionDocuments)
            setDeliveryReportDocuments(res.invoiceDocuments)
        })
    }, []);


    useEffect(() => {
        if (vehicleInitial && Object.keys(vehicleInitial).length)
        {
            setVehicle(vehicleInitial)
        }
    }, [vehicleInitial]);

    const onDrop = (acceptedFiles) => {
        setFileLists(prev => [...prev, ...acceptedFiles])
    }

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
    } = useDropzone({ onDrop })

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {})
        }),
        [isDragActive, isDragReject, isDragAccept]
    )
    const getData = (key) => {
        return axios({
            method: 'GET',
            url: `${API_URL}/vehicle/${id}/${key}`,
        }).then(res => {
            return res.data
        }).catch(err => {
            return err
        })
    }

    const uploadDocument = () => {
        if (fileLists.length) {
            let formData = new FormData()
            for (let index = 0; index < fileLists.length; index++) {
                const element = fileLists[index]
                formData.append(`file[${index}]`, element)
            }
            formData.append('type', imageType)

            axios({
                method: 'POST',
                url: `${API_URL}/vehicle/${id}/documents`,
                data: formData
            })
                .then(response => {
                    if (response.status === 200) {
                        setFileLists([])
                        notify.success('Success')
                        getData('documents').then(res => {
                            const filteredDocuments = res.documents.filter(doc => {
                                return !res.inspectionDocuments.some(inspecDoc => inspecDoc.document.id === doc.id);
                            });
                            setDocuments(filteredDocuments)
                            setInspectionDocuments(res.inspectionDocuments)
                            setDeliveryReportDocuments(res.invoiceDocuments)
                        })

                    }
                })
                .catch(error => {
                    console.error('error :: ', error)

                    notify.warning(error.response && error.response.statusText ? error.response.statusText : 'Error occur.')
                })
        } else {
            notify.warning('Upload file first')
        }
    }

    const viewDocument = (row) => {
        axios({
            method: 'GET',
            url: `${API_URL}/vehicle/${id}/documents/${row.id}`,

        })
            .then(response => {
                if (response.status === 200) {
                    const { data: { file, name } } = response.data;
                    const link = document.createElement('a');
                    link.href = file;
                    link.target = '_blank';
                    link.download = name;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
            .catch(error => {
                console.error('error :: ', error.response)
                notify.warning(error.response && error.response.data.message ? error.response.data.message : error.response.statusText)
            })
    }

    const deleteDocument = (documentId, type = 'uploaded') => {
        axios({
            method: 'DELETE',
            url: `${API_URL}/vehicle/${id}/documents/${documentId}`,
        })
            .then(response => {
                setDeleteModal({
                    ...deleteModal,
                    show: false,
                })
                if (response.status === 204) {
                    let data = response.data
                    if (type === 'inspection') {
                        setInspectionDocuments([...inspectionDocuments.filter(item => item.id !== documentId)])
                    } else {
                        setVehicle({
                            ...vehicle,
                            documents: data.data,
                        })
                    }

                    notify.success(data.message)
                }
            })
            .catch(error => {
                setDeleteModal({
                    ...deleteModal,
                    show: false,
                })
                console.error('error :: ', error.response)
                notify.warning(error.response && error.response.data.message ? error.response.data.message : error.response.statusText)
            })
    }

    const checkDocument = (row) => {
        return (typeof row?.document === 'object')
            ? `Document - ${row.document.document_name}`
            : `Document - ${String(row?.document).split('/').pop()}`;

    }

    const checkDocumentClick = (row) => {

        if (typeof row?.document === 'object') {
            viewDocument(row.document)
        } else {
            downloadDocument(row.document)
        }

    }
    const downloadDocument = (url) => {
        const link = document.createElement("a");
        link.setAttribute('target', '_blank');
        link.href = url;
        link.download = 'file.pdf';
        link.click();
        // fetch(url, { method: 'get', referrerPolicy: 'no-referrer' })
        //     .then(res => res.blob())
        //     .then(res => {
        //
        //       const aElement = document.createElement('a');
        //       aElement.setAttribute('download', url.split('/').pop());
        //       const href = URL.createObjectURL(res);
        //       aElement.href = href;
        //       aElement.setAttribute('target', '_blank');
        //       aElement.click();
        //       URL.revokeObjectURL(href);
        //     });
    };
    return (<CardBody>

        <Modal
            isOpen={deleteModal.show}
            toggle={() => setDeleteModal({
                ...deleteModal,
                show: false
            })}
            className="modal-dialog-centered"
        >
            <div className="modal-header main-color">
                <h6 className="modal-title">{deleteModal.header}</h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => setDeleteModal({
                        ...deleteModal,
                        show: false
                    })}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body ">
                <span>{deleteModal.body}</span>
            </div>
            <div className="modal-footer justify-content-end">
                <ButtonContainer
                    reverse
                    onClick={deleteModal.onClick}
                >
                    {`Delete`}
                </ButtonContainer>
            </div>
        </Modal>
        <Card>
            <CardHeader>
                <h1>Documents</h1>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col md={6} sm={12}>
                        <div className={'documents-tap-container'}>
                            <div className={'text-center'}>
                                <h2>Upload Documents</h2>
                            </div>
                            <div className={'text-center'}>
                                <Input
                                    type="select"
                                    onChange={(e) => setImageType(e.target.value)}
                                    value={imageType}
                                >
                                    {imageTypes &&
                                        imageTypes.map((item) => {
                                            return <option value={item.value} key={item.value}>{item.text}</option>
                                        })
                                    }
                                </Input>
                            </div>
                            <div {...getRootProps({ style })}>
                                <input {...getInputProps()} />
                                <p>Select or drop the documents</p>
                            </div>

                            <aside>
                                {fileLists.map((item, index) => {
                                    return (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                borderBottom: '1px solid #CCC',
                                                alignItems: 'center',
                                                padding: 20,
                                            }}
                                            key={index}
                                        >
                                            <Col md={3} sm={6}>
                                                <span>{item.name}</span>
                                            </Col>
                                            <Col md={3} sm={6}>
                                                <span>{`${item.size} bytes`}</span>
                                            </Col>
                                        </div>
                                    )
                                })}
                            </aside>
                            <div className="d-flex flex-row justify-content-center mt-3 mb-2">
                                <Button className="w-100" color="success" onClick={() => uploadDocument()}>Save</Button>
                            </div>
                        </div>
                    </Col>

                    <Col md={6} sm={12}>
                        <div className={'documents-tap-container'}>
                            <div className={'text-center'}>
                                <h2>Vehicle Documents</h2>
                            </div>
                            {documents ?
                                <TableCustom
                                    loading={false}
                                    className={'documents-table-header'}
                                    items={documents}
                                    keyField={`name`}
                                    noOverflow
                                    searchField={true}
                                    columns={[
                                        {
                                            dataField: "created_at",
                                            text: "Created date",
                                            sort: true,
                                            formatter: (rowContent, row) => {
                                                return `${formatDate(row?.created_at)}`
                                            }
                                        },
                                        {
                                            dataField: "name",
                                            text: "Name",
                                            sort: true,
                                            formatter: (rowContent, row) => {
                                                return `Document - ${row.document_name}`
                                            }
                                        },
                                        {
                                            dataField: "",
                                            text: "View",
                                            formatter: (rowContent, row) => {
                                                return (
                                                    <>
                                                        <IcoMoon
                                                            className={'cursor-pointer'}
                                                            iconSet={IconSet}
                                                            icon={'visibility'}
                                                            size={24}
                                                            onClick={() => viewDocument(row)}
                                                        />
                                                        <IcoMoon
                                                            className={'cursor-pointer'}
                                                            iconSet={IconSet}
                                                            icon={'delete_outline'}
                                                            size={24}
                                                            onClick={() => setDeleteModal({
                                                                ...deleteModal,
                                                                show: true,
                                                                header: 'Delete document',
                                                                body: 'Are you sure to delete this document?',
                                                                onClick: () => deleteDocument(row.id)
                                                            })}
                                                        />
                                                    </>
                                                )
                                            }
                                        }
                                    ]}
                                /> :
                                <div className={'text-center'}>
                                    <h3>
                                        There is no documents yet
                                    </h3>
                                </div>}
                        </div>
                    </Col>
                </Row>

                <Row>

                    <Col md={6} sm={12}>
                        <div className={'documents-tap-container'}>
                            <>
                                <div className={'text-center'}>
                                    <h2>Vehicle Inspection</h2>
                                </div>
                                {inspectionDocuments.length ?
                                    <TableCustom
                                        loading={false}
                                        noOverflow
                                        className={'documents-table-header'}
                                        items={inspectionDocuments}
                                        keyField={`name`}
                                        searchField={true}
                                        columns={[
                                            {
                                                dataField: "created_at",
                                                text: "Date Uploaded",
                                                sort: true,
                                                formatter: (rowContent, row) => {
                                                    return `${formatDate(row?.created_at) || '-'}`
                                                }
                                            },
                                            {
                                                dataField: "name",
                                                text: "Name",
                                                sort: true,
                                                formatter: (rowContent, row) => {
                                                    return checkDocument(row)
                                                }
                                            },
                                            {
                                                dataField: "",
                                                text: "View",
                                                formatter: (rowContent, row) => {
                                                    return (
                                                        <Button color={'success'} onClick={() => checkDocumentClick(row)}>View</Button>
                                                    )
                                                }
                                            }
                                        ]}
                                    />
                                    : <div className={'text-center'}>
                                        <h3>
                                            There is no inspection documents yet
                                        </h3>
                                    </div>
                                }

                            </>
                        </div>
                    </Col>

                    <Col md={6} sm={12}>
                        <div className={'documents-tap-container'}>
                            <>
                                <div className={'text-center'}>
                                    <h2>Delivery Reports</h2>
                                </div>
                                {deliveryReportDocuments.length ?
                                    <TableCustom
                                        loading={false}
                                        noOverflow
                                        className={'documents-table-header'}
                                        items={deliveryReportDocuments}
                                        keyField={`name`}
                                        searchField={true}
                                        columns={[
                                            {
                                                dataField: "created_at",
                                                text: "Date Uploaded",
                                                sort: true,
                                                formatter: (rowContent, row) => {
                                                    return `${formatDate(row?.created_at)}`
                                                }
                                            },
                                            {
                                                dataField: "name",
                                                text: "Name",
                                                sort: true,
                                                formatter: (rowContent, row) => {
                                                    return `Document - ${row?.vehicle_document.document_name.split('/').pop()}`
                                                }
                                            },
                                            {
                                                dataField: "",
                                                text: "View",
                                                formatter: (rowContent, row) => {
                                                    return (
                                                        <Button color={'success'} onClick={() => viewDocument(row.vehicle_document)}>View</Button>
                                                    )
                                                }
                                            }
                                        ]}
                                    /> :
                                    <div className={'text-center'}>
                                        <h3>
                                            There is no delivery reports documents yet
                                        </h3>
                                    </div>
                                }
                            </>
                        </div>
                    </Col>
                </Row>

            </CardBody>
        </Card>
    </CardBody>)
}
export default VehicleDocuments;